import {
  DefaultBadge,
  ListFilesAndTranscriptsBadge,
  ListFilesBadge,
  ListTasksBadge,
  ReadFileBadge,
  ReadFileOrTranscriptBadge,
  ReadTaskBadge,
  ToolCallBadgeProps,
} from './tool-badges';
import { EditDocumentBadge } from './tool-badges/EditDocumentBadge';
import { ReadDocumentBadge } from './tool-badges/ReadDocumentBadge';
import { ReadExampleDemandLetterBadge } from './tool-badges/ReadExampleDemandLetterBadge';
import { SetCaseContextBadge } from './tool-badges/SetCaseContextBadge';
import { SetInitialDocumentDataBadge } from './tool-badges/SetInitialDocumentDataBadge';
import { UpdateTableRowBadge } from './tool-badges/UpdateTableRowBadge';
import { VerifyCaseContextBadge } from './tool-badges/VerifyCaseContextBadge';

export const ToolCallBadge = ({ toolName, ...props }: ToolCallBadgeProps) => {
  switch (toolName) {
    case 'read_file':
    case 'read_file_by_uuid':
      return <ReadFileBadge {...props} />;
    case 'list_files':
      return <ListFilesBadge {...props} />;
    case 'list_files_and_transcripts':
      return <ListFilesAndTranscriptsBadge {...props} />;
    case 'read_file_or_transcript':
      return <ReadFileOrTranscriptBadge {...props} />;
    case 'list_tasks':
      return <ListTasksBadge {...props} />;
    case 'read_task':
      return <ReadTaskBadge {...props} />;
    case 'edit_editor_document':
      return <EditDocumentBadge {...props} />;
    case 'read_editor_document':
      return <ReadDocumentBadge {...props} />;

    case 'read_example_demand_letter':
      return <ReadExampleDemandLetterBadge {...props} />;
    case 'set_initial_document_data':
      return <SetInitialDocumentDataBadge {...props} />;
    case 'set_case_context':
      return <SetCaseContextBadge {...props} />;
    case 'verify_case_context':
      return <VerifyCaseContextBadge {...props} />;
    case 'update_table_row':
      return <UpdateTableRowBadge {...props} />;
    default:
      return <DefaultBadge toolName={toolName} {...props} />;
  }
};
